/**
 * Carrega layouts de tela declarados em lorentz-webphone/views/.
 * Usado pelo app e pelo embed Supervisor (Fase 3+).
 */

const BUILTIN_LAYOUTS = {
  'operator-default': {
    id: 'operator-default',
    label: 'Operador padrão',
    theme: 'auto',
    size: { width: 380, height: 520 },
    panels: {
      extensionStatusBar: true,
      queueBadge: true,
      ctiPanel: true,
      supervisorPanels: false,
      screenPop: true
    },
    features: {
      pwa: true,
      avatarEdit: true,
      themeSwitch: true
    }
  },
  'supervisor-embed': {
    id: 'supervisor-embed',
    label: 'Embed Supervisor',
    theme: 'auto',
    size: { width: 340, height: 520, fill: true },
    panels: {
      extensionStatusBar: true,
      queueBadge: true,
      ctiPanel: true,
      supervisorPanels: false,
      screenPop: true
    },
    lorentz: {
      supervisorEmbed: true
    },
    features: {
      pwa: true,
      avatarEdit: true,
      themeSwitch: true,
      supervisorBridge: true
    },
    supervisor: {
      postMessageTypes: [
        'lorentz:supervisor:init',
        'lorentz:supervisor:ready',
        'lorentz:supervisor:dial',
        'lorentz:transfer',
        'lorentz:supervisor:open-panel'
      ],
      configEndpoint: '/cliente/cli_config.php',
      pollEndpoint: '/cliente/cli_poll.php'
    }
  },
  'operator-compact': {
    id: 'operator-compact',
    label: 'Operador compacto',
    theme: 'auto',
    size: { width: 340, height: 480 },
    panels: {
      extensionStatusBar: true,
      queueBadge: true,
      ctiPanel: false,
      supervisorPanels: false,
      screenPop: true
    }
  }
};

export async function loadViewLayout(layoutId) {
  if (!layoutId) return null;

  if (BUILTIN_LAYOUTS[layoutId]) {
    return { ...BUILTIN_LAYOUTS[layoutId] };
  }

  const paths = [
    `/views/${layoutId}.json`,
    `../views/${layoutId}.json`
  ];

  for (const path of paths) {
    try {
      const res = await fetch(path);
      if (!res.ok) continue;
      const json = await res.json();
      return { id: layoutId, ...json };
    } catch {
      /* try next */
    }
  }

  return BUILTIN_LAYOUTS['operator-default'];
}

export function mergeViewLayout(layout, overrides = {}) {
  return {
    ...layout,
    ...overrides,
    panels: { ...(layout.panels || {}), ...(overrides.panels || {}) },
    features: { ...(layout.features || {}), ...(overrides.features || {}) },
    lorentz: { ...(layout.lorentz || {}), ...(overrides.lorentz || {}) }
  };
}

export function isPanelEnabled(viewLayout, panelId, defaultValue = true) {
  if (!viewLayout?.panels) return defaultValue;
  if (viewLayout.panels[panelId] === undefined) return defaultValue;
  return !!viewLayout.panels[panelId];
}

export { BUILTIN_LAYOUTS };
